import dynamic from 'next/dynamic';
import A from './components/A';
// import css from './index.module.scss';
import EfScrollAni from '@/efscrollani';
import { useGlobal } from '@/utils/useGlobal';

const IndexDynamic = dynamic(() => import('./indexDynamic'), {
    ssr: true,
});

export default function ProductDetail({ callTab }: any) {
    const { useEffect } = useGlobal();

    if (typeof window !== 'undefined' && !window.AniContainer) {
        window.AniContainer = new EfScrollAni();
    }

    useEffect(() => {
        if (typeof window !== 'undefined' && window.AniContainer) {
            return () => AniContainer.destroy();
        }
    }, []);

    return (
        <div className={`shp2-launch-detail`}>
            <A />
            <IndexDynamic callTab={callTab} />
            <style jsx global>
                {`
                    .footer {
                        background-color: #1f1f1f !important;
                        border-top-color: #343434 !important;
                    }
                `}
            </style>
        </div>
    );
}
